import {FC, useState, useEffect, useContext} from 'react'
import {useTranslation} from 'react-i18next'
import {ILanguage} from '../../types/common'
import YearMonthPicker from '../../common/YearMonthPicker'
import InfoBox from '../../common/InfoBox'
import {SessionContext, SessionContextType} from '../../common/ctx/SessionContext'

const FiltersDFE: FC<{
    language: ILanguage
    ctx: any
}> = ({language, ctx}) => {
    const {t} = useTranslation()
    const sessionCtx: SessionContextType = useContext(SessionContext)
    const [excludedDays, setExcludedDays] = useState<Array<Date>>()
    const [selectedDate, setSelectedDate] = useState<Date | undefined>()
    const [datePickerMinDate, setDatePickerMinDate] = useState<Date | undefined>()
    const [datePickerMaxDate, setDatePickerMaxDate] = useState<Date | undefined>()

    useEffect(() => {
        ctx.isDefault()
    }, [])

    useEffect(() => {
        setDatePickerMaxDate(ctx.maxDate)
        setDatePickerMinDate(ctx.minDate)
    }, [ctx.minDate, ctx.maxDate])

    // useEffect(() => {
    //     setSelectedDate(ctx.today)
    // }, [ctx.today])

    useEffect(() => {
        setExcludedDays(ctx.holiday)
    }, [ctx.holiday])

    return (
        <>
            <section id="container-toolbar" className="flex">
                {sessionCtx?.getItem(ctx.STORAGE_KEY) !== 'hidden' && (
                    <InfoBox
                        title={
                            <span>
                                {' '}
                                {t('label.infobox.filters.save')} <br />
                                {t('label.infobox.filters.continue')}{' '}
                            </span>
                        }
                        onCloseCallback={() => {
                            sessionCtx.setItem(ctx.STORAGE_KEY, 'hidden')
                        }}
                    />
                )}
                <div className="filter-bar flex">
                    <div className="up-filter-bar">
                        <div className="grid-column grid-column-dfe flex">
                            <div className="datepickers-item flex">
                                <label className="datepickers-item-label">{t('label.datepicker.title2')}</label>
                                <YearMonthPicker
                                    language={language}
                                    selectedDate={selectedDate}
                                    setSelectedDate={setSelectedDate}
                                    datePickerMinDate={datePickerMinDate}
                                    datePickerMaxDate={datePickerMaxDate}
                                    excludeDates={excludedDays}
                                    withCurrentDate={true}
                                    filterDate={(date) => {
                                        return date.getDay() !== 0 && date.getDay() !== 6
                                    }}
                                    onDateChangeCallback={(date) => {
                                        ctx.setDate(date)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FiltersDFE
